
/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('OptInOut_Resource',["$resource","$location",
        function ($resource,$location)
        {
            var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
            return $resource(baseUrl+'rest/optInOut/:id',{}, {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' },
            });
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OptInOut',["OptInOut_Resource","OptInOutData",
        function (OptInOut_Resource,OptInOutData)
        {
            var OptInOut = function (resource, customerId)
            {
                this.id = null;
                this.isSmsCampaignAllowed = null;
                this.isEmailCampaignAllowed = null;
                this.isNotificationCampaignAllowed = null;
                this.isExternalOptInOut = null;
                this.origin = null;
                this.timeModified = null;
                this.customerId = customerId;
                this.version = null;

                if(resource !== undefined && resource !== null)
                    this.setValues(resource);
                
                OptInOutData.add(this);
            };

            OptInOut.prototype.setId = function(id)
            {
                if (!this.id)
                    this.id = id;
            };

            OptInOut.prototype.getId = function()
            {
                return this.id;
            };

            OptInOut.prototype.setValues = function(resource)
            {
                this.id = resource.id;
                this.isSmsCampaignAllowed = resource.isSmsCampaignAllowed;
                this.isEmailCampaignAllowed = resource.isEmailCampaignAllowed;
                this.isNotificationCampaignAllowed = resource.isNotificationCampaignAllowed;
                this.isExternalOptInOut = resource.isExternalOptInOut;
                this.origin = resource.origin;
                this.timeModified = resource.timeModified;

                this.isDeleted = resource.isDeleted;
                if(resource.version)
                    this.version = resource.version;
            };

            OptInOut.prototype.getObjectResource = function()
            {
                var newOptInOut = new OptInOut_Resource();

                newOptInOut.id = this.id;
                newOptInOut.isSmsCampaignAllowed = this.isSmsCampaignAllowed;
                newOptInOut.isEmailCampaignAllowed = this.isEmailCampaignAllowed;
                newOptInOut.isNotificationCampaignAllowed = this.isNotificationCampaignAllowed;
                if(!this.isExternalOptInOut)
                    newOptInOut.isExternalOptInOut = false;
                else
                    newOptInOut.isExternalOptInOut = true;
                newOptInOut.timeModified = this.timeModified;
                newOptInOut.origin = this.origin;
                newOptInOut.customerId = this.customerId;
                newOptInOut.isDeleted = this.isDeleted;

                return newOptInOut;
            };

            return OptInOut;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OptInOutSrv',["$log","ServerSrv","OptInOut_Resource","OptInOutData","UserActionData","OptInOut","CustomerData",
        function ($log,ServerSrv,OptInOut_Resource,OptInOutData,UserActionData,OptInOut,CustomerData)
        {
            var optInOutSrv = {};

            optInOutSrv.save = function(optInOut,successFunction,errorFunction)
            {
                ServerSrv.startSavingProcess(optInOutSrv.saveSync, optInOut, successFunction, errorFunction);
            };

            optInOutSrv.saveSync = function(optInOut,successFunction,errorFunction)
            {
                var optInOutRes = optInOut.getObjectResource();
                optInOutRes.$save({},
                    function (data) {
                        try{
                            optInOut.setId(data.id);
                            if (!optInOut.version || (data.version && data.version > optInOut.version))
                                optInOut.version = data.version;
                            if (successFunction !== undefined && successFunction !== null)
                                successFunction(optInOut);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try{
                            if (errorFunction !== undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };

            optInOutSrv.updateLocally = function(id,object)
            {
                var optInOut = OptInOutData.getById(id);
                if (optInOut!=null){
                    optInOut.setValues(object);
                }
                return optInOut;
            };

            optInOutSrv.addLocally = function(id,object)
            {
                var optInOut = OptInOutData.getById(id);
                if (optInOut==null) {
                    var optInOut = new OptInOut(object, object.customerId);
                    optInOut.id = id;

                    var customer = CustomerData.getById(optInOut.customerId);
                    if(customer)
                        customer.optInOut = optInOut;

                }
                return optInOut;
            };

            optInOutSrv.removeLocally = function(id,object)
            {
                var optInOut = OptInOutData.getById(id);
                if (optInOut!=null){
                    var customer = CustomerData.getById(optInOut.customerId);
                    if(customer)
                        customer.removeOptInOut(optInOut);
                    OptInOutData.remove(optInOut);
                }

                return optInOut;
            };

            return optInOutSrv;
        }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OptInOutData',[
        function ()
        {
            var optInOutData =
            {
                optInOutList : [], // optInOut scheduler list for the entire application
                deletedOptInOutList : [] // deleted optInOut scheduler list for the entire application
            };
            optInOutData.getById =  function(optInOutId)
            {
                for (var i=0;i<this.optInOutList.length;i++)
                    if (this.optInOutList[i].id==optInOutId)
                        return this.optInOutList[i];
                return null;
            };
            optInOutData.getByIndex =  function(optInOutIndex)
            {
                if (optInOutIndex >= 0 && optInOutIndex < this.optInOutList.length)
                {
                    return this.optInOutList[optInOutIndex];
                }
                else
                    return null;
            };
            optInOutData.getIndexOf =  function(optInOut)
            {
                if (optInOut)
                    return this.optInOutList.indexOf(optInOut);
                return -1;
            };
            optInOutData.add = function(optInOut)
            {
                if(!optInOut.isDeleted)
                    this.optInOutList.push(optInOut);
                else
                    this.deletedOptInOutList.push(optInOut);
            };
            optInOutData.remove = function(optInOut) //Soft Remove
            {
                if (optInOut && !optInOut.isDeleted) {
                    var indexOptInOut = this.optInOutList.indexOf(optInOut);
                    if (indexOptInOut != -1) {
                        this.optInOutList.splice(indexOptInOut, 1);
                        this.deletedOptInOutList.push(optInOut);
                        optInOut.isDeleted = true;
                    }
                }
            };
            optInOutData.getOptInOutList = function()
            {
                return this.optInOutList;
            };
            optInOutData.clear = function()
            {
                this.optInOutList = [];
                this.deletedOptInOutList = [];
            };


            return optInOutData;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/OptInOut.js